export default __webpack_public_path__ + "static/media/coach_guide_lancingkit_lancets100_strips250_gray@3x.5cd38ef8.jpg";